/** Закрытые списки, из которых складывается облик профиля.
 *
 *  Имени у профиля нет вовсе: семилетка узнаёт себя по картинке быстрее, чем
 *  по строке, а свободного текста, вводимого пользователем, у профиля нет —
 *  нечего экранировать и нечему утекать в журнал ошибок.
 *
 *  Списки живут в слое данных, а не в интерфейсе, потому что это словарь
 *  значений, которые ложатся в базу и уедут на сервер. Картинки к ним —
 *  в `src/ui/animals.tsx`. */
export const COLORS = ['blue', 'green', 'amber', 'rose', 'violet', 'teal'] as const;
export const ANIMALS = ['hedgehog', 'fox', 'cat', 'owl'] as const;

export type Color = (typeof COLORS)[number];
export type Animal = (typeof ANIMALS)[number];

/** Пара «цвет и зверёк» уникальна в пределах учётной записи, а профилей до
 *  двенадцати — значит сочетаний должно хватать с запасом. Шесть на четыре
 *  дают двадцать четыре. Сторожит `tests/ui/looks.test.ts`. */
export const PROFILE_LIMIT = 12;

/** Облик профиля, который заводится сам при первом запуске, пока экрана
 *  выбора ещё нет. */
export const DEFAULT_LOOK = { color: COLORS[0], animal: ANIMALS[0] };

export function isColor(value: string): value is Color {
  return (COLORS as readonly string[]).includes(value);
}

export function isAnimal(value: string): value is Animal {
  return (ANIMALS as readonly string[]).includes(value);
}
